import Clarity from "@microsoft/clarity";
import { getCookie } from "react-use-cookie";

export type EventProps = {
  action: string;
  allowCustomScripts?: boolean;
  callback?(): void;
  category?:
    | "Path"
    | "SERP"
    | "404"
    | "Contact"
    | "Opt-out"
    | "Survey"
    | "ATTB Redirect"
    | "Exception";
  label?: string;
  nonInteraction?: boolean;
  sendTo?: string | string[];
  transport?: "beacon";
  value?: number;
};

export type ConversionEventProps = {
  callback?(): void;
  value: number;
  currency: "USD" | "GBP";
};

const DOMAIN = process.env.GATSBY_DOMAIN; //eg "us.best-jobs-online.com"

const isGAEnabled = () => typeof window?.gtag !== "undefined";

// we only want to fire this once per session
let hasFired = false;
async function trackUserEvent() {
  const id = getCookie("reg:smsId");
  if (!id || hasFired) {
    return;
  }
  // trackCustomDimensions({
  //   reg_sms_id: id,
  // });
  const searchParams = new URLSearchParams(window.location.search);
  try {
    const response = await fetch(`https://api-v2.${DOMAIN}/events`, {
      method: "POST",
      body: JSON.stringify({
        event: "click", // can accept "sign-up" as well but might be deprecated
        id,
        position: searchParams.get("position"),
        location: searchParams.get("location"),
        userAgent: navigator.userAgent,
      }),
    });
    if (!response.ok) {
      throw new Error("Error tracking user event");
    }
    hasFired = true;
  } catch (e) {
    trackCustomException(e.message);
  }
}

export function trackCustomEvent({
  action,
  allowCustomScripts,
  callback,
  category,
  label,
  nonInteraction,
  sendTo,
  transport,
  value,
}: EventProps) {
  trackUserEvent();
  Clarity.event(`${category} | ${action} | ${label}`);

  if (isGAEnabled()) {
    window.gtag("event", action, {
      allow_custom_scripts: allowCustomScripts,
      event_callback: callback,
      event_category: category,
      event_label: label,
      non_interaction: nonInteraction,
      send_to: sendTo,
      transport_type: transport,
      value,
    });
  } else {
    console.log(
      `GA event: ${action} ${category ? `(${category})` : ""} ${
        label ? `(${label})` : ""
      }`
    );
    callback?.();
  }
}

export function trackConversionEvent({
  callback,
  value,
  currency,
}: ConversionEventProps) {
  Clarity.event(`Conversion | ${value} | ${currency}`);
  if (isGAEnabled()) {
    window.gtag("event", "conversion", {
      event_callback: callback,
      send_to: "AW-943638748/_lZSCJnIosICENyR-8ED",
      value,
      currency,
    });
  } else {
    callback?.();
  }

  window.uetq = window.uetq || [];
  window.uetq.push("event", "outbound_click", {
    revenue_value: value,
    currency,
  });
}

export function trackCustomException(description: string, fatal?: boolean) {
  Clarity.event(`Exception | ${description}`);
  if (!isGAEnabled()) return;
  window.gtag("event", "exception", {
    description,
    fatal,
  });
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function trackCustomDimensions(dimensions: Record<string, any>) {
  if (!isGAEnabled()) return;
  window.gtag("set", dimensions);
}
